const api_url = '/index.php';
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

export default {
    namespaced: true,

    state: {
        allFilters: [],
        userFilters: [],
        saveUserFilters: [],
    },

    mutations: {
        setAllFilters(state, allFilters) {
            state.allFilters = allFilters;
        },

        setUserFilters(state, userFilters) {
            state.userFilters = userFilters;
        },

        setSaveUserFilters(state, saveUserFilters) {
            state.saveUserFilters = saveUserFilters;
        },
    },

    getters: {
        getAllFilters(state) {
            return state.allFilters;
        },

        getUserFilters(state) {
            return state.userFilters;
        },

        getSaveUserFilters(state) {
            return state.saveUserFilters;
        },
    },

    actions: {
        async getAllFilters(ctx) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/finance-transaction/filters`, token));

            const json = await res.json();

            ctx.commit('setAllFilters', json);

            return json;
        },

        async getUserFilters(ctx) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/finance-transaction/user-filters&user_id=${userId}`, token));

            const json = await res.json();

            ctx.commit('setUserFilters', json);
        },

        async saveUserFilters(ctx, filters) {
            const {userId} = ctx.rootState;
            const token = ctx.rootState.authToken;

            const form_data = new FormData();

            form_data.append('filters', JSON.stringify(filters));
            form_data.append('user_id', userId);

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/finance-transaction/save-user-filters`, token),
                {
                    method: 'post',
                    body: form_data,
                });

            const json = await res.json();

            if (json.response) {
                ctx.commit('setUserFilters', {filters});
            }
        },

        async getWorkerById(ctx, id) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/get-worker&worker_id=${id}`, token));

            const json = await res.json();

            return json;
        },
        async getWorkerBalances(ctx, id) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker/balances&worker_id=${id}`, token));

            const json = await res.json();

            return json;
        },
        async getFilialsWithWorkerBalances(ctx, id) {
            const token = ctx.rootState.authToken;

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/directory/filial-sort-with-balance&worker_id=${id}`, token));

            const json = await res.json();

            return json;
        },

    },
};